/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class UniversalStorageService {
        constructor(private $http: ng.IHttpService, private baseService: BaseService) {
        }

        public getFiles(filter: ResultFilterModel) {
            return this.post('archive/{companyNumber}/file/search', filter).then(j => { return j.data });
        }

        public scroll(scrollId: string) {
            if (scrollId == null || scrollId == '') {
                return
            }
            return this.get(`archive/{companyNumber}/file/scroll?scrollId=${scrollId}`).then(j => { return j.data });
        }

        public updateTags(id: string, tags: TagsWrapperModel) {
            return this.put('archive/{companyNumber}/file/' + id + '/tags', tags).then(j => { return j.data });
        }

        public uploadFiles(associationId: string, departmentId: string, localizer: string, data: FormData) {
            return this.upload(`archive/{companyNumber}/file/upload?associationId=${associationId}&departmentId=${departmentId}&localizer=${localizer}`, data).then(j => { return j.data });
        }

        public downloadFiles(ids: string[]) {
            return this.postArrayBuffer('archive/{companyNumber}/file/download', ids).then(data => data.data);
        }

        public updateDescription(id: string, description: string) {
            return this.put('archive/{companyNumber}/file/' + id + '/description', { description: description }).then(j => { return j.data });
        }

        public updateIssueDate(id: string, issueDate: string) {
            if (issueDate == null) {
                issueDate = '';
            }
            return this.put('archive/{companyNumber}/file/' + id + '/issueDate', { date: issueDate }).then(j => { return j.data });
        }

        public getThumbnailUrl(originalUrl: string) {
            return 'image/resize?imageUrl=' + encodeURIComponent(originalUrl);
        }

        public searchTags(searchText: string) {
            return this.get('archive/{companyNumber}/file/searchTags?searchText=' + searchText).then(j =>
            {
                return <string[]>j.data;
            });
        }

        private upload(url: string, data: FormData) {
          return this.baseService.upload(url, data);
        }

        public postArrayBuffer(url: string, data: any) {
          return this.baseService.postArrayBuffer(url, data);
        }

        public post(url: string, data: any) {
          return this.baseService.post(url, data);
        }

        public put(url: string, data: any) {
          return this.baseService.put(url, data);
        }

        private get(url: string) {
          return this.baseService.get(url);
        }

        public delete(id: string) {
          return this.baseService.delete('archive/{companyNumber}/file/' + id + '/deleteById').then(d => d.data);
        }
    }

    UniversalStorageService.$inject = ['$http', 'BaseService'];
    angular
        .module('eseebase')
        .service('UniversalStorageService', UniversalStorageService);
}